module.exports = __webpack_public_path__ + "img/metale.2afbc35c.jpg";